<div *ngIf="viewed">
  <ng-container *ngIf="loading && !detail; else viewDetail">
    <mat-spinner color="primary" diameter="48"></mat-spinner>
  </ng-container>
  <ng-template #viewDetail>
    <div class="preview-container">
      <client-adjustment-header
        [title]="'Te plaatsen'"
        [type]="detail.expectedType.toLowerCase()"
        [currentCreatedAt]="detail.currentCreatedAt"
        [projectContacts]="detail.project.projectContacts"
        [extraCompanyContacts]="detail.project.projectExtraCompanyContacts"
        [client]="true"
      ></client-adjustment-header>
      <ng-container *ngIf="detail.project.products?.length > 0">
        <project-detail-card
          [cardType]="'configuration'"
          [products]="detail.project.products"
          [firstProduct]="detail.project.products[0]"
          [project]="detail.project"
          [client]="true"
        ></project-detail-card>

        <project-detail-card
          [cardType]="'design'"
          [products]="detail.project.products"
          [assets]="detail.designPictures"
          [ipBoardExamples]="ipBoardExamples"
          [project]="detail.project"
        ></project-detail-card>

        <project-detail-card
          [cardType]="'placement'"
          [firstProduct]="detail.project.products[0]"
          [projectPlacement]="detail.projectPlacement"
          [baseProject]="detail"
          [project]="detail.project"
          [assets]="placementAssets"
          [client]="true"
        ></project-detail-card>

        <project-detail-card
          [cardType]="'execution'"
          [products]="detail.project.products"
          [baseProject]="detail"
          [project]="detail.project"
          [assets]="executionAssets"
          [client]="true"
          [componentsExecuted]="detail.componentsExecuted"
        ></project-detail-card>
      </ng-container>

      <ng-container *ngIf="selectedCompany == null; else showFacturation">
        <mat-spinner color="primary" diameter="24"></mat-spinner>
      </ng-container>
      <ng-template #showFacturation>
        <project-detail-card
          *ngIf="!detail.fromOldSystem"
          [cardType]="'facturation'"
          [project]="detail.project"
          [baseProject]="detail"
          [company]="selectedCompany"
          [client]="true"
        ></project-detail-card>
      </ng-template>
    </div>

    <client-detail-actions
      *ngIf="!forAtelier"
      [client]="true"
      [subProject]="detail"
    ></client-detail-actions>
  </ng-template>
</div>
